/**
 * @generated SignedSource<<ea6b8de4e1fa15eaedf478f2b49e4bad>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}
export type FetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous_profilePicture_Icon =
  {
    __typename?: "Icon";
    isDefault: boolean | null;
    path: string;
  };
export type FetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: FetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous_profilePicture_Icon | null;
  };
export type FetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: FetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous_profilePicture_Icon | null;
  };
export type FetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_UnknownUser =
  {
    __typename?: "UnknownUser";
    accountId: string | null;
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: FetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous_profilePicture_Icon | null;
  };
export type FetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_User =
  {
    __typename?: "User";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: FetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous_profilePicture_Icon | null;
  };
export type FetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes =

    | FetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous
    | FetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_KnownUser
    | FetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_UnknownUser
    | FetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_User;
export type FetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList =
  {
    __typename?: "PaginatedPersonList";
    nodes: Array<FetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes | null> | null;
  };
export type FetchPresenceConfluenceUsersQuery_Query = {
  __typename?: "Query";
  confluenceUsers: FetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList | null;
};
export type FetchPresenceConfluenceUsersQueryVariables = Exact<{
  accountIds?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
}>;
export type FetchPresenceConfluenceUsersQuery =
  FetchPresenceConfluenceUsersQuery_Query;
